import React, { useState } from "react";

const FAQs = ({ data }) => {
  const [activeFAQ, setActiveFAQ] = useState(0);

  return (
    <div className="flex w-full basis-full flex-wrap">
      {data?.map((faq, index) => (
        <div className="w-full basis-full">
          <button
            key={index}
            className={`flex w-full basis-full justify-between border-b border-solid border-white bg-secondary px-4 py-4 font-futuraMd text-xl text-white`}
            onClick={(e) => {
              e.preventDefault();
              setActiveFAQ((prevState) => index);
            }}
          >
            <span>{faq.title}</span>
            {activeFAQ === index ? (
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.6978 0.945465H2.57275C2.15214 0.945465 1.74875 1.11255 1.45133 1.40998C1.15391 1.7074 0.986816 2.11079 0.986816 2.5314V20.6564C0.986816 21.077 1.15391 21.4804 1.45133 21.7778C1.74875 22.0753 2.15214 22.2423 2.57275 22.2423H20.6978C21.1184 22.2423 21.5218 22.0753 21.8192 21.7778C22.1166 21.4804 22.2837 21.077 22.2837 20.6564V2.5314C22.2837 2.11079 22.1166 1.7074 21.8192 1.40998C21.5218 1.11255 21.1184 0.945465 20.6978 0.945465ZM20.9243 20.6564C20.9243 20.7165 20.9004 20.7741 20.858 20.8166C20.8155 20.8591 20.7578 20.883 20.6978 20.883H2.57275C2.51267 20.883 2.45504 20.8591 2.41255 20.8166C2.37006 20.7741 2.34619 20.7165 2.34619 20.6564V2.5314C2.34619 2.47131 2.37006 2.41369 2.41255 2.3712C2.45504 2.32871 2.51267 2.30484 2.57275 2.30484H20.6978C20.7578 2.30484 20.8155 2.32871 20.858 2.3712C20.9004 2.41369 20.9243 2.47131 20.9243 2.5314V20.6564ZM16.8462 11.5939C16.8462 11.7742 16.7746 11.947 16.6471 12.0745C16.5196 12.202 16.3468 12.2736 16.1665 12.2736H7.104C6.92374 12.2736 6.75086 12.202 6.62339 12.0745C6.49593 11.947 6.42432 11.7742 6.42432 11.5939C6.42432 11.4136 6.49593 11.2408 6.62339 11.1133C6.75086 10.9858 6.92374 10.9142 7.104 10.9142H16.1665C16.3468 10.9142 16.5196 10.9858 16.6471 11.1133C16.7746 11.2408 16.8462 11.4136 16.8462 11.5939Z"
                  fill="#fff"
                />
              </svg>
            ) : (
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.6978 0.851562H2.57275C2.15214 0.851562 1.74875 1.01865 1.45133 1.31607C1.15391 1.61349 0.986816 2.01688 0.986816 2.4375V20.5625C0.986816 20.9831 1.15391 21.3865 1.45133 21.6839C1.74875 21.9813 2.15214 22.1484 2.57275 22.1484H20.6978C21.1184 22.1484 21.5218 21.9813 21.8192 21.6839C22.1166 21.3865 22.2837 20.9831 22.2837 20.5625V2.4375C22.2837 2.01688 22.1166 1.61349 21.8192 1.31607C21.5218 1.01865 21.1184 0.851562 20.6978 0.851562ZM20.9243 20.5625C20.9243 20.6226 20.9004 20.6802 20.858 20.7227C20.8155 20.7652 20.7578 20.7891 20.6978 20.7891H2.57275C2.51267 20.7891 2.45504 20.7652 2.41255 20.7227C2.37006 20.6802 2.34619 20.6226 2.34619 20.5625V2.4375C2.34619 2.37741 2.37006 2.31978 2.41255 2.2773C2.45504 2.23481 2.51267 2.21094 2.57275 2.21094H20.6978C20.7578 2.21094 20.8155 2.23481 20.858 2.2773C20.9004 2.31978 20.9243 2.37741 20.9243 2.4375V20.5625ZM16.8462 11.5C16.8462 11.6803 16.7746 11.8531 16.6471 11.9806C16.5196 12.1081 16.3468 12.1797 16.1665 12.1797H12.3149V16.0312C12.3149 16.2115 12.2433 16.3844 12.1159 16.5119C11.9884 16.6393 11.8155 16.7109 11.6353 16.7109C11.455 16.7109 11.2821 16.6393 11.1546 16.5119C11.0272 16.3844 10.9556 16.2115 10.9556 16.0312V12.1797H7.104C6.92374 12.1797 6.75086 12.1081 6.62339 11.9806C6.49593 11.8531 6.42432 11.6803 6.42432 11.5C6.42432 11.3197 6.49593 11.1469 6.62339 11.0194C6.75086 10.8919 6.92374 10.8203 7.104 10.8203H10.9556V6.96875C10.9556 6.78849 11.0272 6.6156 11.1546 6.48814C11.2821 6.36067 11.455 6.28906 11.6353 6.28906C11.8155 6.28906 11.9884 6.36067 12.1159 6.48814C12.2433 6.6156 12.3149 6.78849 12.3149 6.96875V10.8203H16.1665C16.3468 10.8203 16.5196 10.8919 16.6471 11.0194C16.7746 11.1469 16.8462 11.3197 16.8462 11.5Z"
                  fill="#fff"
                />
              </svg>
            )}
          </button>
          <div
            className={`page-content my-4 w-full basis-full px-4 font-futuraLt text-xl font-semibold text-bannergrey ${
              activeFAQ === index ? "block" : "hidden"
            }`}
            dangerouslySetInnerHTML={{
              __html: faq.content,
            }}
          ></div>
        </div>
      ))}
    </div>
  );
};

export default FAQs;
